import { createUncategorizedNodes } from '../../../utils/item/createUncategorizedNodes';
import { getUncategorizedItems } from '../api/items';
import { CATALOG_TYPE_MASTER } from '../../../utils/types/catalogTypes';
import { PANE_SOURCETREE, PANE_TARGETTREE } from '../../constants/panes';
import { CATALOG_STATUS_ACTIVE } from '../../../utils/statuses/catalogStatus';
import { updateData } from '../../slices/tree';
import type { AppThunkDispatch, RootState } from '../..';

export const fetchUncategorizedItems =
  (tree: string, catalogId: string) =>
  async (dispatch: AppThunkDispatch, getState: () => RootState) => {
    const items = await dispatch(getUncategorizedItems()).unwrap();
    const state = getState();
    const panes = state.pane;

    if (!panes[PANE_SOURCETREE] || !panes[PANE_TARGETTREE]) {
      return null;
    }

    const showPredictions =
      (panes[PANE_SOURCETREE].catalogType === CATALOG_TYPE_MASTER &&
        panes[PANE_SOURCETREE].catalogStatus === CATALOG_STATUS_ACTIVE) ||
      (panes[PANE_TARGETTREE].catalogType === CATALOG_TYPE_MASTER &&
        panes[PANE_TARGETTREE].catalogStatus === CATALOG_STATUS_ACTIVE);

    const uncategorizedNodes = createUncategorizedNodes({
      catalogId,
      items,
      showPredictions,
    });
    return dispatch(
      updateData(tree, uncategorizedNodes, {
        meta: {
          totalNumberOfElements: items.length,
        },
      }),
    );
  };
